import * as React from "react";
import { Box, Typography } from "@mui/material";
import { platformFonts } from "../tickitPlatformTheme";

export default function PlatformActionSection({ title, children }) {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        sx={{
          fontFamily: platformFonts.body,
          fontSize: "0.6875rem",
          fontWeight: 700,
          color: "var(--platform-text-3)",
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          mb: 1,
        }}
      >
        {title}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>{children}</Box>
    </Box>
  );
}
